import { CanActivateFn } from '@angular/router';
import { createAuthGuard } from 'keycloak-angular';

/**
 * Defense-in-depth: blocks route activation when the user is not authenticated.
 * Redundant with the bootstrap-time Keycloak gate (see keycloak-provider.ts), but
 * ensures no route can render unauthenticated even if the app is somehow reached.
 */
export const authGuard: CanActivateFn = createAuthGuard(
  async (_route, _state, { authenticated }) => authenticated,
);
